import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ActivityContainer from 'views/ActivityContainer';
import ActivityPlayButtonOverlay from '../ActivityPlayButtonOverlay/ActivityPlayButtonOverlay';
import { handleRepeatActivity } from 'store/actions/activity';
import { handleSettingChangeSubscription } from 'utils/accessibilityUtils';
import { setOverlayBlocked, currentAudioSingleton } from 'utils/assetLoader';

const LiteSessionActivity = () => {
  const [showOverlay, setShowOverlay] = useState(true);
  const dispatch = useDispatch();
  const {
    settings: {
      accessibility: {
        audioSettings: { muteSounds }
      }
    }
  } = useSelector(state => state.student || {});

  const onPlayButtonOverlayClick = () => setShowOverlay(() => false);

  useEffect(() => {
    setOverlayBlocked(showOverlay);
    if (showOverlay) {
      currentAudioSingleton.get()?.pause();
    } else {
      handleSettingChangeSubscription('muteSounds', muteSounds);
      dispatch(handleRepeatActivity());
    }
  }, [showOverlay]);

  return (
    <>
      {showOverlay && <ActivityPlayButtonOverlay onOverlayClick={onPlayButtonOverlayClick} />}
      <ActivityContainer overlayActive={showOverlay} />
    </>
  );
};

LiteSessionActivity.propTypes = {
  handleRepeatActivity: PropTypes.func
};

export default LiteSessionActivity;
